import { UsersDetailsPluginsTab } from "./UsersDetailsPluginsTab";

export default UsersDetailsPluginsTab;
